import { Logger } from "../common";

/**
 * Abstract Logger Interface
 * Provides consistent logging across frontend and backend
 */
export interface ILogger {
    /**
     * Log informational messages
     */
    log(message: string, ...args: any[]): void;

    /**
     * Log error messages
     */
    error(message: string, ...args: any[]): void;

    /**
     * Log warning messages
     */
    warn(message: string, ...args: any[]): void;

    /**
     * Log debug messages (may be disabled in production)
     */
    debug(message: string, ...args: any[]): void;

    /**
     * Log success messages
     */
    info(message: string, ...args: any[]): void;
}

/**
 * No-op logger (does nothing)
 * Useful for testing or when logging is disabled
 */
export class NoOpLogger implements ILogger {
    log(_message: string, ..._args: any[]): void { }
    error(_message: string, ..._args: any[]): void { }
    warn(_message: string, ..._args: any[]): void { }
    debug(_message: string, ..._args: any[]): void { }
    info(_message: string, ..._args: any[]): void { }
}

/**
 * Basic Console Logger
 */
export class ConsoleLogger implements ILogger {
    constructor(private prefix: string = '') { }

    private formatMessage(message: string): string {
        return this.prefix ? `[${this.prefix}] ${message}` : message;
    }

    log(message: string, ...args: any[]): void {
        Logger.log(this.formatMessage(message), ...args);
    }

    error(message: string, ...args: any[]): void {
        Logger.error(this.formatMessage(message), ...args);
    }

    warn(message: string, ...args: any[]): void {
        Logger.warn(this.formatMessage(message), ...args);
    }

    debug(message: string, ...args: any[]): void {
        Logger.debug(this.formatMessage(message), ...args);
    }

    info(message: string, ...args: any[]): void {
        Logger.info(this.formatMessage(message), ...args);
    }
}
